import { useTranslation } from "react-i18next";
import signupIcon from "@app/dashboard/assets/images/outerLayout/signup-icon.svg";
import customerServiceIcon from "@app/dashboard/assets/images/outerLayout/customer-service-icon.svg";
import styles from "./promo-section.module.scss";

const PROMO_HIGHLIGHT_ICONS = [signupIcon, customerServiceIcon, signupIcon] as const;

type TPromoHighlight = {
  title: string;
  description: string;
};

const PromoSection = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const highlights: TPromoHighlight[] = t('outerLayout.promo.highlights', { returnObjects: true });

  return (
    <div className={styles['promo-section']}>
      <div className={styles['promo-section__content']}>
        <h1 className={styles['promo-section__content__title']}>
          {t('outerLayout.promo.titlePrefix')}
          <strong className={styles['promo-section__content__title__brand-name']}>{t('outerLayout.promo.titleStrong')}</strong>
        </h1>
        <p className={styles['promo-section__content__subtitle']}>
          {t('outerLayout.promo.subtitle')}
        </p>

        <ul className={styles['promo-section__content__list']}>
          {highlights.map((item, index) => (
            <li key={`outer-layout-promo-highlight-${index}`}>
              <span className={styles['promo-section__content__list__icon']}>
                <img
                  src={PROMO_HIGHLIGHT_ICONS[index]}
                  aria-hidden
                />
              </span>
              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <span className={styles['promo-section__copyright']}>
        {t('outerLayout.footerCopyright', { year: currentYear })}
      </span>
    </div>
  )
}

export default PromoSection;
